<template>
    <form class="is-clearfix">
        <h1 class="title is-3">Create Service</h1>
        <div class="columns">
            <div class="column">
                <o-field label="Name">
                    <o-input></o-input>
                </o-field>

                <o-field label="Price">
                    <o-input></o-input>
                </o-field>

                <o-field label="Notes">
                    <o-input maxlength="200" type="textarea"></o-input>
                </o-field>
            </div>
        </div>

        <div class="field is-grouped is-pulled-right">
            <p class="control">
                <router-link :to="{ name: 'services.index' }" class="button" >Cancel</router-link>
            </p>
            <p class="control">
                <button @click.prevent="success" class="button is-success">Save</button>
            </p>
        </div>
    </form>
</template>

<script>
    import Datepicker from '../../components/Datepicker';

    export default {
        components: {
            Datepicker
        },

        data() {
            return {

            }
        },

        methods: {
            success() {
                this.$swal.fire({
                    text: 'Service has been successfull created',
                    icon: 'success'
                })
            },
        }
    }
</script>
